import React, { useEffect, useState } from 'react';
import { FormControlLabel, Grid } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import {useHistory, useLocation, useParams} from "react-router-dom";
import customer_api, {SetDefaultUrl, SetGClubUrl} from "../api/customer_api";
import { useGlobalStore } from "../store/GlobalContext";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AssignmentIndSharpIcon from '@material-ui/icons/AssignmentIndSharp';
import MenuItem from '@material-ui/core/MenuItem';
import Button from "@material-ui/core/Button";
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import ConfirmRegisterDialog from "../components/Modal/ConfirmRegisterDialog";
import {map} from "store/src/util";

const useQuery = () => {
    return new URLSearchParams( useLocation().search );
}

const useStyles = makeStyles( ( theme ) => ( {
    root: {
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: '#000000',
        justifyContent: 'center'
    },
    root2: {
        border: `1px solid ${theme.palette.secondary.main}`,
        backgroundColor: '#000000',
        justifyContent: 'center'
    },
    input: {
        color: '#FFFFFF'
    },
    select: {
        backgroundColor: '#000000',
        color: `#FFFFFF`,
        '&:select': {
            color: `#FF0000`,
            // backgroundColor:`transparent`
        },
        '&:hover': {
            color: `#000000`,
            backgroundColor: `#transparent`,
        },
        '&:focus': {
            color: `#FF0000`,
            // backgroundColor:`transparent`
        },
    },
    disabledButton: {
        backgroundColor: process.env.REACT_APP_PRIMARY_THEME_COLOR || 'red'
    },
    selectDropdown: {
        width: '100%',
        "& .MuiSvgIcon-root": {
            "&.MuiSelect-icon": {
                "&.MuiSelect-iconOutlined": {
                    color: '#ffffff'
                },
            }
        }
    },
} ) );

const checkCustomerPromotions = async(token, dispatch, callback_function)=>{
    const request = {
        token: token
    }

    try{
        const response = await customer_api.CHECK_CUSTOMER_PROMOTIONS(request)
        // console.log("check customer promotions response: ", response)
        if(callback_function){
            void callback_function()
        }

    }catch (e){
        console.log("check customer promotions error:", e?.response?.data?.message)
        if(e.response?.data?.message && callback_function){
            dispatch( { type: 'error_message_dialog_with_register', error_code: "410", payload: { data: e.response.data.message, callback_function: callback_function } } )
        }else{
            dispatch( { type: 'error_message_dialog', payload: { data: e?.response?.data?.message } } )
        }

    }
}

export const RegisterStepComponents = ( props ) => {
    const classes = useStyles();
    let history = useHistory();
    let query = useQuery();

    const [ { customer_register }, dispatch ] = useGlobalStore()
    const [ registerStepOne, setRegisterStepOne ] = useState( {
        agent_name: customer_register.agent_name,
        first_name: customer_register.first_name,
        last_name: customer_register.last_name,
        mobile_no: customer_register.mobile_no,
        name_accept_flag: customer_register.name_accept_flag,
    } )

    //console.log(registerStepOne)

    const [ registerStepOneError, setRegisterStepOneError ] = useState( {
        errorFirstName: false,
        errorLastName: false,
        errorMobileNo: false,
        errorNameAcceptFlag: false,
    } )


    const { nextAction } = props

    useEffect( () => {

        const queryParamMap = {}

        for (const [key, value] of query.entries()) {
            // console.log("key: ", key)
            // console.log("value: ", value)
            if(value !== undefined){
                queryParamMap[key] = value
            }
        }
        queryParamMap["agent_id"] = process.env.REACT_APP_UFA_AGENT_ID
        // console.log("query params: ", queryParamMap)

        let agent = queryParamMap["agent"]
        let agent_prefix_name = queryParamMap["agent_prefix_name"]
        let agent_sub_id = queryParamMap["s"]

        let agent_name = ""
        // let agent_id = process.env.REACT_APP_UFA_AGENT_ID
        if ( agent !== "ufa" && agent !== "gclub" ) {
            history.push( "/login" )
            return
        } else {
            agent_name = agent.concat( '_auto' )
            queryParamMap["agent_name"] = agent.concat( '_auto' )
        }
        if ( agent_prefix_name !== "" && agent_prefix_name != null ) {

            const request = { agent, agent_prefix_name }
            customer_api.PRE_REGISTER( request )
                .then( response => {
                    const { data } = response.data
                    // setRegisterStepOne( { ...registerStepOne, agent_name: agent_name, agent_id: data.agent_id } )
                    setRegisterStepOne( { ...registerStepOne, ...queryParamMap } )
                    // console.log("registerStepOne: ", registerStepOne)
                    if (data.logo === "" ) {
                        dispatch( { type: 'logo_register', payload: { data: process.env.REACT_APP_LOGO_PATH } } )
                    } else {
                        dispatch( { type: 'logo_register', payload: { data: data.logo } } )
                    }
                } )
                .catch( error => {
                    //console.log("error: ", error)
                    if (agent_sub_id !== "" && agent_sub_id != null){
                        queryParamMap["agent_id"] = agent_sub_id
                    }

                    //setRegisterStepOne( { ...registerStepOne, agent_name: agent_name, agent_id: agent_id } )
                    setRegisterStepOne( { ...registerStepOne, ...queryParamMap } )
                    // console.log("registerStepOne: ", registerStepOne)
                    dispatch( { type: 'logo_register', payload: { data: process.env.REACT_APP_LOGO_PATH } } )
                } )
        } else {
            if (agent_sub_id !== "" && agent_sub_id != null){
                queryParamMap["agent_id"] = agent_sub_id
            }
            // setRegisterStepOne( { ...registerStepOne, agent_name: agent_name, agent_id: agent_id } )
            setRegisterStepOne( { ...registerStepOne, ...queryParamMap } )
            // console.log("register#1: ", registerStepOne)
            dispatch( { type: 'logo_register', payload: { data: process.env.REACT_APP_LOGO_PATH } } )
        }

        const token = queryParamMap["token"]
        if(token){
            void checkCustomerPromotions(token, dispatch)
        }

    }, [] )

    const submitStepOne = ( event ) => {
        event.preventDefault();
        setRegisterStepOneError( {
            ...registerStepOneError,
            errorFirstName: false,
            errorLastName: false,
            errorMobileNo: false,
            errorNameAcceptFlag: false,
        } )

        //console.log( 'registerStepOne:', registerStepOne);
        if ( registerStepOne.first_name === '' || registerStepOne.first_name === undefined ) {
            setRegisterStepOneError( { ...registerStepOneError, errorFirstName: true } )
            return
        }

        if ( registerStepOne.first_name.match( /[^a-zA-Z\u0E01-\u0E2E\u0E30-\u0E39\u0E47\u0E40-\u0E44\u0E48-\u0E4B\u0E4C]/g ) ) {
            setRegisterStepOneError( { ...registerStepOneError, errorFirstName: true } )
            return
        }

        if ( registerStepOne.last_name === '' || registerStepOne.last_name === undefined ) {
            setRegisterStepOneError( { ...registerStepOneError, errorLastName: true } )
            return
        }

        if ( registerStepOne.last_name.match( /[^a-zA-Z\u0E01-\u0E2E\u0E30-\u0E39\u0E47\u0E40-\u0E44\u0E48-\u0E4B\u0E4C]/g ) ) {
            setRegisterStepOneError( { ...registerStepOneError, errorLastName: true } )
            return
        }

        if ( registerStepOne.mobile_no === '' || registerStepOne.mobile_no === undefined ) {
            setRegisterStepOneError( { ...registerStepOneError, errorMobileNo: true } )
            return
        }

        if ( !registerStepOne.mobile_no.match( /^\d{10}$/ ) ) {
            setRegisterStepOneError( { ...registerStepOneError, errorMobileNo: true } )
            return
        }

        if ( registerStepOne.name_accept_flag !== true ) {
            setRegisterStepOneError( { ...registerStepOneError, errorNameAcceptFlag: true } )
            return
        }

        customer_api.PROSPECT( registerStepOne )
            .then( () => {
                // console.log(response)
                dispatch( { type: 'customer_register', payload: { data: registerStepOne } } )
                nextAction()
            } )
            .catch( error => {
                //console.log("error prospect register step 1: ", error)
            } )
    }

    return (
        <Grid container
              direction="column"
              justify="center"
              alignItems="center"
              spacing={2}
        >
            <Grid item xs={11} md={4} xl={4} style={{ width: '100%' }}>
                <form noValidate={false} onSubmit={submitStepOne}>
                    <Accordion className={classes.root} expanded={true}>
                        <AccordionSummary
                            className={classes.root}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <AssignmentIndSharpIcon color={'primary'}/>
                            <Typography display={'inline'} color={'primary'}>สมัครออโต้</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TextField
                                error={registerStepOneError.errorFirstName}
                                id="outlined-firstname-required"
                                label="ชื่อ"
                                variant="outlined"
                                name="first_name"
                                style={{ width: '100%' }}
                                focused
                                onBlur={( e ) => setRegisterStepOne( {
                                    ...registerStepOne,
                                    first_name: e.target.value
                                } )}
                                defaultValue={customer_register.first_name}
                                helperText="*กรุณาระบุชื่อ(ไม่สามารถระบุตัวเลขได้)"
                            />
                        </AccordionDetails>
                        <AccordionDetails>
                            <TextField
                                error={registerStepOneError.errorLastName}
                                id="outlined-lastname-required"
                                label="นามสกุล"
                                name="last_name"
                                variant="outlined"
                                style={{ width: '100%' }}
                                onBlur={( e ) => setRegisterStepOne( {
                                    ...registerStepOne,
                                    last_name: e.target.value
                                } )}
                                focused
                                defaultValue={customer_register.last_name}
                                helperText="*กรุณาระบุนามสกุล(ไม่สามารถระบุตัวเลขได้)"
                            />
                        </AccordionDetails>
                        <AccordionDetails>
                            <TextField
                                error={registerStepOneError.errorMobileNo}
                                id="outlined-mobile_no-input"
                                label="เบอร์มือถือ"
                                name="mobile_no"
                                variant="outlined"
                                style={{ width: '100%' }}
                                onBlur={( e ) => setRegisterStepOne( {
                                    ...registerStepOne,
                                    mobile_no: e.target.value
                                } )}
                                focused
                                defaultValue={customer_register.mobile_no}
                                helperText="*กรุณาระบุเบอร์มือถือ 10 หลัก(ตัวเลขเท่านั้น)"
                            />
                        </AccordionDetails>
                        <AccordionDetails
                            style={{ justifyContent: 'center', color: process.env.REACT_APP_PRIMARY_THEME_COLOR }}>
                            <FormControl required error={registerStepOneError.errorNameAcceptFlag === true}
                                         component="fieldset">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={registerStepOne.name_accept_flag === true}
                                            defaultValue={customer_register.name_accept_flag}
                                            onChange={( e ) => setRegisterStepOne( {
                                                ...registerStepOne,
                                                name_accept_flag: !registerStepOne.name_accept_flag
                                            } )}
                                            size={"small"}
                                            name="name_accept_flag"
                                            style={{ color: process.env.REACT_APP_PRIMARY_THEME_COLOR }}
                                        />
                                    }
                                    label="ยืนยันชื่อและนามสกุลตรงกับเลขที่บัญชีที่ใช้สมัคร"
                                />
                                <FormHelperText style={{color:'red', alignSelf:"center"}}>*
                                    หากข้อมูลไม่ตรงกันขออนุญาติตัดสิทธิ์
                                </FormHelperText>
                                <FormHelperText style={{color:'red', alignSelf:"center"}}>
                                    การเป็นสมาชิก เพื่อป้องกันมิจฉาชีพ
                                </FormHelperText>
                                <FormHelperText hidden={registerStepOneError.errorNameAcceptFlag === false}>*
                                    กรุณายืนยันชื่อนามสกุลที่ใช้สมัครตรงกับเลขที่บัญชี</FormHelperText>
                            </FormControl>
                        </AccordionDetails>
                        <AccordionDetails>
                            <Button variant={"contained"} size="large"
                                    style={{ width: '100%', margin: '3px' }}
                                    color="primary" type={"submit"}>
                                ต่อไป
                            </Button>
                        </AccordionDetails>
                    </Accordion>
                </form>
            </Grid>
        </Grid>

    )
}

export const RegisterStepTwo = ( props ) => {
    const classes = useStyles();
    let history = useHistory();
    let query = useQuery();

    const [ { customer_register }, dispatch ] = useGlobalStore()
    const [ thaiBanklists, setThaiBanklists ] = useState( [] )
    // const [bankAccountDetails, ] = useState({})
    // const [bankAccountNo, ] = useState('')
    const [ registerStepTwo, setRegisterStepTwo ] = useState( {
        bank_short_name: customer_register.bank_short_name, bank_account_no: customer_register.bank_account_no
    } )

    const { previousAction, nextAction } = props
    const getBanklist = async() => {
        await customer_api.GET_THAI_BANK_API()
            .then( response => {
                const data = response.data.data
                //console.log("get thai bank response banks: ", data)
                setThaiBanklists( data )

            } )
            .catch( error => {
                const errorMessage = error.response
                if ( errorMessage === undefined ) {
                    dispatch( {
                        type: 'error_message_dialog',
                        payload: { data: "ขออภัยระบบไม่สามารถดำเนินการได้ กรุณาลองใหม่ภายหลัง" }
                    } )
                } else {
                    dispatch({
                        type: 'error_message_dialog',
                        payload: { data: `${errorMessage.data.message}`}
                    })
                }

            })
    }

    useEffect( () => {
        const agent = query.get( "agent" )
        if ( agent !== "ufa" && agent !== "gclub" ) {
            //console.log( "agent:", agent )
            history.push( "/login" )
        }
        void getBanklist()
    }, [] )


    const [ registerStepTwoError, setRegisterStepTwoError ] = useState( {
        errorBankShortName: false,
        errorBankAccountNo: false
    } )

    const changeBank = ( bankShortName ) => {
        //setBankAccountNo('')
        //console.log("changeBank bankShortName : ", bankShortName)
        if ( bankShortName === 'เลือกธนาคาร' ) {
            return
        }
        const bankAccountName = thaiBanklists.find( ( { value } ) => value === bankShortName ).text
        const bankCode = thaiBanklists.find( ( { value } ) => value === bankShortName ).code

        //console.log("bank_short_name", bankShortName)
        //console.log("bank_account_name", bankAccountName)
        //console.log("bank_code", bankCode)
        // const bankDetails = {
        //     bank_short_name: String(bankShortName),
        //     bank_account_name: String(bankAccountName),
        //     bank_code: String(bankCode),
        //     is_main_bank_account: true
        // }

        setRegisterStepTwo( {
            ...registerStepTwo,
            bank_short_name: bankShortName,
            bank_account_name: bankAccountName,
            bank_code: bankCode
        } )
        //console.log("changeBank registerStepTwo : ", registerStepTwo)
    }

    const submitStepTwo = ( event ) => {
        event.preventDefault();
        setRegisterStepTwoError( {
            errorBankShortName: false,
            errorBankAccountNo: false
        } )

        if ( registerStepTwo.bank_short_name === 'เลือกธนาคาร' || registerStepTwo.bank_short_name === undefined ) {
            setRegisterStepTwoError( { ...registerStepTwoError, errorBankShortName: true } )
            return
        }

        if ( registerStepTwo.bank_account_no === '' || registerStepTwo.bank_account_no === undefined ) {
            setRegisterStepTwoError( { ...registerStepTwoError, errorBankAccountNo: true } )
            return
        }

        if ( !registerStepTwo.bank_account_no.match( /^!*([0-9]!*){10,}$/ ) ) {
            setRegisterStepTwoError( { ...registerStepTwoError, errorBankAccountNo: true } )
            return
        }

        //console.log("registerStepTwo.bank_accounts : ", registerStepTwo.bank_accounts)

        // const bankAccounts = [{
        //     ...bankAccountDetails,
        //     bank_account_no: bankAccountNo
        // }]
        //console.log("bankAccounts :", bankAccounts)

        // setRegisterStepTwo({...registerStepTwo, bank_accounts: bankAccounts})
        //console.log("registerStepTwo submit: ", registerStepTwo)
        dispatch( { type: 'customer_register', payload: { data: registerStepTwo } } )
        nextAction()
    }
    return (
        <Grid container
              direction="column"
              justify="center"
              alignItems="center"
              spacing={2}
        >
            <Grid item xs={11} md={4} xl={4} style={{ width: '100%' }}>
                <form noValidate={false} onSubmit={submitStepTwo}>
                    <Accordion className={classes.root} expanded={true}>
                        <AccordionSummary
                            className={classes.root}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <AssignmentIndSharpIcon color={'primary'}/>
                            <Typography display={'inline'} color={'primary'}>ข้อมูลบัญชีรับเงิน</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ marginTop: '15px' }}>
                            <TextField
                                select
                                error={registerStepTwoError.errorBankShortName}
                                id="outlined-bank-input"
                                label="เลือกธนาคาร"
                                className={classes.selectDropdown}
                                focused
                                defaultValue={
                                    ( customer_register.bank_short_name !== '' && customer_register.bank_short_name !== undefined ) ? customer_register.bank_short_name : "เลือกธนาคาร"
                                }
                                variant={"outlined"}
                                onChange={( e ) => changeBank( e.target.value )}
                                helperText="*กรุณาเลือกธนาคารรับโอน"
                            >
                                <MenuItem key={"กรุณาเลือกธนาคาร"} value={"เลือกธนาคาร"} className={classes.select}>
                                    {"กรุณาเลือกธนาคาร"}
                                </MenuItem>
                                {thaiBanklists.map( ( option ) => (
                                    <MenuItem key={option.text} value={option.value} className={classes.select}>
                                        {option.text}
                                    </MenuItem>
                                ) )}
                            </TextField>
                        </AccordionDetails>
                        <AccordionDetails>
                            <TextField
                                error={registerStepTwoError.errorBankAccountNo}
                                id="outlined-lastname-input"
                                label="เลขที่บัญชี"
                                variant="outlined"
                                style={{ width: '100%' }}
                                focused
                                defaultValue={customer_register.bank_account_no}
                                onBlur={( e ) => setRegisterStepTwo( {
                                    ...registerStepTwo,
                                    bank_account_no: e.target.value
                                } )}
                                helperText="*กรุณาระบุเลขที่บัญชี อย่างน้อย 10 หลัก (ตัวเลขเท่านั้น)"
                            />
                        </AccordionDetails>
                        <AccordionDetails>
                            <Button variant={"outlined"} size="large"
                                    style={{ width: '50%', margin: '5px', borderWidth: '2px', borderColor: 'white' }}
                                    onClick={previousAction}>
                                ย้อนกลับ
                            </Button>
                            <Button variant={"contained"} size="large" type={"submit"}
                                    style={{ width: '50%', margin: '5px' }}
                                    color="primary">
                                ต่อไป
                            </Button>
                        </AccordionDetails>
                    </Accordion>
                </form>
            </Grid>
        </Grid>

    )
}

export const RegisterStepThree = ( props ) => {
    const history = useHistory()
    const classes = useStyles();
    let query = useQuery();
    const [refKeyword, setRefKeyword] = useState("");
    const [inviteKey, setInviteKey] = useState("");

    const [ { customer_register }, dispatch ] = useGlobalStore()
    const { previousAction } = props
    const [ openConfirmDialog, setOpenConfirmDialog ] = useState( false )
    const [ loadingRegister, setLoadingRegister ] = useState( true )

    const [ registerStepThree, setRegisterStepThree ] = useState( {
        channel: customer_register.channel,
        age_flag: false,
        line_id: customer_register.line_id,
        reference_user_id: customer_register.reference_user_id
    } )

    const [ registerStepThreeError, setRegisterStepThreeError ] = useState( {
        errorChannel: false,
        errorAgeFlag: false,
        errorFriends: false
    } )

    const [ registerConfirmData, setRegisterConfirmData ] = useState( {} )

    const changeChannel = ( channel ) => {
        setRegisterStepThree( { ...registerStepThree, channel_select: channel } )
        setRegisterStepThreeError( { ...registerStepThreeError, errorFriends: true } )
    }

    const registerNewUser = async( registerStepThree ) => {

        const bankAccounts = [ {
            bank_short_name: customer_register.bank_short_name,
            bank_account_name: customer_register.bank_account_name,
            bank_code: customer_register.bank_code,
            bank_account_no: customer_register.bank_account_no,
            is_main_bank_account: true
        } ]

        //console.log("customer_register before submit :", customer_register)
        const registerData = {
            ...customer_register,
            bank_accounts: bankAccounts,
            status: "normal",
            money_site_name: process.env.REACT_APP_MONEY_SITE_NAME,
            channel_select: registerStepThree.channel_select,
            line_id: registerStepThree.line_id,
            reference_user_id: registerStepThree.reference_user_id,
            age_flag: registerStepThree.age,
            ref_keyword: refKeyword ? refKeyword : "",
            invite_key: inviteKey ? inviteKey : "",
        }

        // console.log("demo new register data :", registerData)
        // setRegisterConfirmData( { user_id: "ufyuxxxxxxx", password: "pwdxxxxxxx" } )
        // setLoadingRegister( false )
        // history.push({pathname:"/register_complete", state:{username: "ufyuxxxxxxx", password:"pwdxxxxxxx"}})
        // return
        // console.log("new register data: ", registerData)

        await customer_api.CREATE_CUSTOMER( registerData )
            .then( response => {
                // console.log("response.data.data: ", response.data.data)
                // setTranactions(response.data.data)
                setLoadingRegister( false )
                const responseData = response.data.data
                setRegisterConfirmData( { user_id: responseData.user_id, password: responseData.password } )
                history.push({pathname:"/register_complete", state:{username: responseData.user_id, password:responseData.password}})
            } )
            .catch( error => {
                setLoadingRegister( false )
                setOpenConfirmDialog( false )
                //console.log("error :", error)

                const errorMessage = error.response
                if ( errorMessage === undefined ) {
                    dispatch( {
                        type: 'error_message_dialog',
                        payload: { data: "ขออภัยระบบไม่สามารถดำเนินการได้ กรุณาลองใหม่ภายหลัง" }
                    } )
                } else {
                    dispatch( { type: 'error_message_dialog', payload: { data: `${error.response.data.message} (${error.response.data.code || ""})` }})
                }
            } )
        setLoadingRegister( false )
    }

    const submitStepThree = ( event ) => {
        event.preventDefault();

        if ( customer_register.bank_short_name === 'เลือกธนาคาร' || customer_register.bank_short_name === undefined ) {
            dispatch( { type: 'error_message_dialog', payload: { data: "กรุณาเลือกธนาคารฝาก" } } )
            return
        }

        if ( customer_register.bank_account_no === '' || customer_register.bank_account_no === undefined ) {
            dispatch( { type: 'error_message_dialog', payload: { data: "กรุณาระบุเลขที่บัญชี" } } )
            return
        }

        if ( !customer_register.bank_account_no.match( /^[0-9]*$/ ) ) {
            dispatch( { type: 'error_message_dialog', payload: { data: "รูปแบบข้อมูลบัญชีไม่ถูกต้อง" } } )
            return
        }

        setRegisterStepThreeError( {
            errorChannel: false,
            errorAgeFlag: false,
            errorFriends: false
        } )

        if ( registerStepThree.channel_select === '' || registerStepThree.channel_select === undefined ) {
            setRegisterStepThreeError( { ...registerStepThreeError, errorChannel: true } )
            return
        }

        if ( registerStepThree.age_flag === '' || registerStepThree.age_flag === false ) {
            setRegisterStepThreeError( { ...registerStepThreeError, errorAgeFlag: true } )
            return
        }

        if ( registerStepThree.channel_select === 'friends' && ( registerStepThree.reference_user_id === '' && registerStepThree.reference_user_id === undefined ) ) {
            setRegisterStepThreeError( { ...registerStepThreeError, errorFriends: true } )
            return
        }

        //console.log( 'registerStepThree:', registerStepThree);
        if(customer_register.token){
            // console.log("has token: ", customer_register.token)
            void checkCustomerPromotions(customer_register.token, dispatch, ()=>{
                dispatch( { type: 'customer_register', payload: { data: registerStepThree } } )
                setLoadingRegister( true )
                setOpenConfirmDialog( true )
                void registerNewUser( registerStepThree )
            })
        }else{
            dispatch( { type: 'customer_register', payload: { data: registerStepThree } } )
            setLoadingRegister( true )
            setOpenConfirmDialog( true )
            void registerNewUser( registerStepThree )
        }
    }

    const channelOptions = ( [
        { text: 'Google', value: 'google' },
        { text: 'Facebook', value: 'facebook' },
        { text: 'Twitter', value: 'twitter' },
        { text: "Youtube", value: "youtube" },
        { text: "TikTok", value: "tiktok" },
        { text: 'เพื่อนแนะนำ', value: 'friends' }
    ] )

    useEffect( () => {
        setRefKeyword(query.get( "ref_keyword" ));
        setInviteKey(query.get( "invite_key" ));
    }, [] );

    return (
        <Grid container
              direction="column"
              justify="center"
              alignItems="center"

        >
            <ConfirmRegisterDialog openDialog={openConfirmDialog} onLoading={loadingRegister}
                                   registerConfirmData={registerConfirmData}/>
            <Grid item xs={11} md={4} xl={4} style={{ width: '100%' }}>
                <form noValidate={false} onSubmit={submitStepThree}>
                    <Accordion className={classes.root} expanded={true}>
                        <AccordionSummary
                            className={classes.root}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <AssignmentIndSharpIcon color={'primary'}/>
                            <Typography display={'inline'} color={'primary'}>ข้อมูลช่องทางการสมัคร</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TextField
                                error={registerStepThreeError.errorChannel}
                                id="outlined-bank-input"
                                label="ช่องทางการสมัคร"
                                select
                                className={classes.selectDropdown}
                                focused
                                name={"channel"}
                                defaultValue={customer_register.channel_select}
                                variant={"outlined"}
                                onChange={( e ) => changeChannel( e.target.value )}
                                helperText="*กรุณาเลือกช่องทางการสมัคร"
                            >
                                <MenuItem key={"กรุณาเลือกช่องทาง"} value={"เลือกช่องทาง"} className={classes.select}>
                                    {"กรุณาเลือกช่องทาง"}
                                </MenuItem>
                                {channelOptions.map( ( option ) => (
                                    <MenuItem key={option.text} value={option.value} className={classes.select}>
                                        {option.text}
                                    </MenuItem>
                                ) )}
                            </TextField>
                        </AccordionDetails>
                        {( registerStepThree.channel_select === 'friends' ) ?
                            ( <AccordionDetails>
                                <TextField
                                    error={registerStepThreeError.errorFriends}
                                    id="reference_user_id-input"
                                    label="กรุณาระบุผู้แนะนำ (ถ้ามี)"
                                    name={"reference_user_id"}
                                    variant="outlined"
                                    style={{ width: '100%' }}
                                    focused
                                    onBlur={( e ) => setRegisterStepThree( {
                                        ...registerStepThree,
                                        reference_user_id: e.target.value
                                    } )}
                                    helperText="*กรุณาเลือกระบุผู้แนะนำ"
                                />
                            </AccordionDetails> ) :
                            ( <></> )
                        }
                        <AccordionDetails>
                            <TextField
                                id="outlined-lastname-input"
                                label="LINE ID (optional)"
                                variant="outlined"
                                style={{ width: '100%' }}
                                focused
                                name={"line_id"}
                                defaultValue={customer_register.line_id}
                                onBlur={( e ) => setRegisterStepThree( {
                                    ...registerStepThree,
                                    line_id: e.target.value
                                } )}
                            />
                        </AccordionDetails>
                        <AccordionDetails
                            style={{ justifyContent: 'center', color: process.env.REACT_APP_PRIMARY_THEME_COLOR }}>
                            <FormControl required error={registerStepThreeError.errorAgeFlag === true}
                                         component="fieldset">
                                {/*<FormLabel component="legend">ยืนยันผู้สมัครมีอายุ 18 ปีขึ้นไป</FormLabel>*/}
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={registerStepThree.age_flag === true}
                                            defaultValue={false}
                                            onChange={( e ) => setRegisterStepThree( {
                                                ...registerStepThree,
                                                age_flag: !registerStepThree.age_flag
                                            } )}
                                            name="age_flag"
                                            style={{ color: process.env.REACT_APP_PRIMARY_THEME_COLOR }}
                                        />
                                    }
                                    label="ยืนยันผู้สมัครมีอายุ 18 ปีขึ้นไป"
                                />
                                <FormHelperText>*กรุณายืนยันอายุผู้สมัคร</FormHelperText>
                            </FormControl>
                        </AccordionDetails>
                        <AccordionDetails>
                            <Button variant={"outlined"} size="large"
                                    style={{ width: '50%', margin: '2px', borderWidth: '2px', borderColor: 'white' }}
                                    onClick={previousAction}>
                                ย้อนกลับ
                            </Button>
                            <Button variant={"contained"} size="large" type={"submit"}
                                    style={{ width: '50%', margin: '2px' }}
                                    color="primary">
                                สมัครสมาชิก
                            </Button>
                        </AccordionDetails>
                    </Accordion>
                </form>
            </Grid>
        </Grid>

    )
}